import { w as r } from "./index-DrV-rJDO.js";
export {
  r as analytics
};
